// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Qw-z","tooltipWrapper":"Rw-z","icon":"Sw-z","tooltip":"Tw-z","content":"Uw-z"};